import React, { useEffect, useState } from "react";
import { Row, Col, CardBody, Card, Alert, Container, Input, Label, Form, FormFeedback, Button, Spinner } from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// action
import { registerUser, resetRegisterFlag } from "../../slices/thunks";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useNavigate } from "react-router-dom";

//import images
import logoLight from "../../assets/images/full_logo.png";
import ParticlesAuth from "../../Components/Common/ParticlesAuth";
import { createSelector } from "reselect";

const Register = () => {
    const history = useNavigate();
    const dispatch: any = useDispatch();
    const [loader, setLoader] = useState<boolean>(false);

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            email: '',
            first_name: '',
            password: '',
            confirm_password: ''
        },
        validationSchema: Yup.object({
            email: Yup.string().email("Endereço de email inválido").required("Por favor insira seu email"),
            first_name: Yup.string().required("Por favor insira seu nome de usuário"),
            password: Yup.string()
                .min(8, "A senha deve ter no mínimo 8 caracteres")
                .matches(/[A-Z]/, "A senha deve conter pelo menos uma letra maiúscula")
                .matches(/[a-z]/, "A senha deve conter pelo menos uma letra minúscula")
                .matches(/[0-9]/, "A senha deve conter pelo menos um número")
                .matches(/[@$!%*?&#]/, "A senha deve conter pelo menos um caractere especial (@$!%*?&#)")
                .required("Por favor insira sua senha"),
            confirm_password: Yup.string()
                .oneOf([Yup.ref('password'), ""], "As senhas devem coincidir")
                .required('Confirmação de senha é obrigatória')
        }),
        onSubmit: (values) => {
            dispatch(registerUser(values));
            setLoader(true)
        }
    });

    const selectLayoutState = (state: any) => state.Account;
    const registerdatatype = createSelector(
        selectLayoutState,
        (account) => ({
            success: account.success,
            error: account.error
        })
    );
    // Inside your component
    const {
        error, success
    } = useSelector(registerdatatype);

    useEffect(() => {
        if (success) {
            setTimeout(() => history("/login"), 3000);
        }

        setTimeout(() => {
            dispatch(resetRegisterFlag());
        }, 3000);

    }, [dispatch, success, error, history]);

    document.title = "Registro | Atos Cloud";

    return (
        <React.Fragment>
            <style>{`
                @media (max-width: 576px) {
                    .auth-page-content-mobile {
                        margin-top: -40px !important;
                    }
                    .auth-logo-mobile {
                        margin-top: 30px !important;
                        margin-bottom: 0 !important;
                    }
                    .auth-logo-mobile img {
                        height: 120px !important;
                        max-width: 90vw !important;
                    }
                    .auth-card-mobile {
                        margin-top: 0.75rem !important;
                    }
                }
                @media (min-width: 577px) {
                    .auth-page-content-mobile {
                        margin-top: -120px !important;
                    }
                    .auth-logo-mobile {
                        margin-top: 100px !important;
                    }
                    .auth-logo-mobile img {
                        height: 240px !important;
                    }
                    .auth-card-mobile {
                        margin-top: 1rem !important;
                    }
                }
            `}</style>
            <ParticlesAuth>
                <div className="auth-page-content auth-page-content-mobile">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center text-white-50 auth-logo-mobile">
                                    <div>
                                        <Link to="/" className="d-inline-block auth-logo">
                                            <img src={logoLight} alt="" />
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="auth-card-mobile">

                                    <CardBody className="p-4">
                                        <div className="text-center mt-2">
                                            <h5 className="text-primary">Criar Nova Conta</h5>
                                            <p className="text-muted">Registre-se gratuitamente no Atos Cloud</p>
                                        </div>
                                        <div className="p-2 mt-4">
                                            <Form
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    validation.handleSubmit();
                                                    return false;
                                                }}
                                                className="needs-validation" action="#">

                                                {success && success ? (
                                                    <>
                                                        {toast("Redirecionando para a página de login...", { position: "top-right", hideProgressBar: false, className: 'bg-success text-white', progress: undefined, toastId: "" })}
                                                        <ToastContainer autoClose={2000} limit={1} />
                                                        <Alert color="success">
                                                            Usuário registrado com sucesso! Redirecionando para a página de login...
                                                        </Alert>
                                                    </>
                                                ) : null}

                                                {error && error ? (
                                                    <Alert color="danger"><div>
                                                        Este email já está cadastrado. Por favor, use outro endereço de email.</div></Alert>
                                                ) : null}

                                                <div className="mb-3">
                                                    <Label htmlFor="useremail" className="form-label">Email <span className="text-danger">*</span></Label>
                                                    <Input
                                                        id="email"
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="Digite seu endereço de email"
                                                        type="email"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.email || ""}
                                                        invalid={
                                                            validation.touched.email && validation.errors.email ? true : false
                                                        }
                                                    />
                                                    {validation.touched.email && validation.errors.email ? (
                                                        <FormFeedback type="invalid"><div>{validation.errors.email}</div></FormFeedback>
                                                    ) : null}

                                                </div>
                                                <div className="mb-3">
                                                    <Label htmlFor="username" className="form-label">Nome de Usuário <span className="text-danger">*</span></Label>
                                                    <Input
                                                        name="first_name"
                                                        type="text"
                                                        placeholder="Digite seu nome de usuário"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.first_name || ""}
                                                        invalid={
                                                            validation.touched.first_name && validation.errors.first_name ? true : false
                                                        }
                                                    />
                                                    {validation.touched.first_name && validation.errors.first_name ? (
                                                        <FormFeedback type="invalid"><div>{validation.errors.first_name}</div></FormFeedback>
                                                    ) : null}

                                                </div>

                                                <div className="mb-3">
                                                    <Label htmlFor="userpassword" className="form-label">Senha <span className="text-danger">*</span></Label>
                                                    <Input
                                                        name="password"
                                                        type="password"
                                                        placeholder="Ex: ProMed@123"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.password || ""}
                                                        invalid={
                                                            validation.touched.password && validation.errors.password ? true : false
                                                        }
                                                    />
                                                    {validation.touched.password && validation.errors.password ? (
                                                        <FormFeedback type="invalid"><div>{validation.errors.password}</div></FormFeedback>
                                                    ) : null}
                                                    <div className="form-text text-muted">
                                                        Mín. 8 caracteres: 1 maiúscula, 1 minúscula, 1 número, 1 caractere especial
                                                    </div>
                                                </div>

                                                <div className="mb-2">
                                                    <Label htmlFor="confirmPassword" className="form-label">Confirmar Senha <span className="text-danger">*</span></Label>
                                                    <Input
                                                        name="confirm_password"
                                                        type="password"
                                                        placeholder="Confirme sua senha"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.confirm_password || ""}
                                                        invalid={
                                                            validation.touched.confirm_password && validation.errors.confirm_password ? true : false
                                                        }
                                                    />
                                                    {validation.touched.confirm_password && validation.errors.confirm_password ? (
                                                        <FormFeedback type="invalid"><div>{validation.errors.confirm_password}</div></FormFeedback>
                                                    ) : null}

                                                </div>

                                                <div className="mt-4">
                                                    <Button color="success" className="w-100" type="submit" disabled={loader && true}>
                                                        {loader && <Spinner size="sm" className='me-2'> Loading... </Spinner>}
                                                        Registrar
                                                    </Button>
                                                </div>

                                                <div className="mt-4 text-center">
                                                    <p className="mb-0">Já tem uma conta? <Link to="/login" className="fw-semibold text-primary text-decoration-underline"> Entrar </Link> </p>
                                                </div>
                                            </Form>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default Register;
